import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Ogólne',
    [tabs.restaurant_details]: 'Dane restauracji',
    [tabs.order_conversion]: 'Konwersja zamówień',
    [tabs.external_delivery]: 'Dostawa zewnętrzna',
    [tabs.mobile_app]: 'Aplikacja mobilna',
    [tabs.customer_success_team]: 'Zespół obsługi klienta',
    [tabs.onboarding_team]: 'Zespół onboardingu',
  },
  date_range: {
    this_month: 'Ten miesiąc',
    last_month: 'Ostatni miesiąc',
    last_week: 'Ostatni tydzień',
    last_year: 'Ostatni rok',
    this_week: 'Ten tydzień',
    this_year: 'Ten rok',
    today: 'Dziś',
    yesterday: 'Wczoraj',
    all: 'Wszystkie',
  },
};
